import { render } from "./Home.vue?vue&type=template&id=8715920c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8715920c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8715920c"

export default script